<!--Desktop Banner-->
<div class="bg-primary pt-3 d-none d-lg-block" role="banner">
  <div class="container">
    <div class="d-none d-lg-flex text-white page-back-button-section align-items-center" [routerLink]="['/games']">
      <span class="material-icons me-2">arrow_back_ios_new</span>
    </div>
  </div>
</div>
<div class="bg-primary">
  <div class="container">
    @if (isDefault) {
    <img class="trivia-banner" [src]="'member/games/trivia-banner.png' | contentAssetImage" alt="trivia-banner" />
    } @if (isKid) { @if (kidType$ | async; as kidType) {
    <img
      class="trivia-banner"
      [src]="
        (kidType == 'All-Stars' ? 'kids/games/allstars/trivia-banner.png' : 'kids/games/baller/trivia-banner.png')
          | contentAssetImage
      "
      alt="trivia-banner"
    />
    } } @if (isClub1901) {
    <img class="trivia-banner" [src]="'1901/games/trivia-banner.png' | contentAssetImage" alt="trivia-banner" />
    }
  </div>
</div>
<!--Mobile Navigation-->
<fgb-mobile-nav-menu [pageName]="'games.page.trivia.title' | translate"></fgb-mobile-nav-menu>
<div class="bg-primary nav-container">
  <fgb-route-nav>
    <a
      class="nav-item leaderboard-nav-item"
      routerLink="/games/trivia"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'game.nav.play' | translate : { fgbdefault: 'Play' } }}</label>
    </a>
    <a
      class="nav-item leaderboard-nav-item"
      routerLink="/games/trivia/leaderboard"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'game.nav.leaderboard' | translate : { fgbdefault: 'Leaderboard' } }}</label>
    </a>
  </fgb-route-nav>
</div>
<div class="mobile-page-content">
  <router-outlet></router-outlet>
</div>
